import { render, staticRenderFns } from "./GeneralListItem.vue?vue&type=template&id=7040fd32&scoped=true"
import script from "./GeneralListItem.vue?vue&type=script&lang=js"
export * from "./GeneralListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040fd32",
  null
  
)

export default component.exports